module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-&-Webprofits-Video-1.81d7e41d.webp";